import { TbBold as BoldIcon } from "react-icons/tb";
import { GoItalic as ItalicIcon } from "react-icons/go";
import { RxUnderline as UnderlineIcon } from "react-icons/rx";
import { RxStrikethrough as StrikeIcon } from "react-icons/rx";
import { RiH1 as H1Icon } from "react-icons/ri";
import { RiH2 as H2Icon } from "react-icons/ri";
import { RiH3 as H3Icon } from "react-icons/ri";
import { BsTextLeft as TextLeftIcon } from "react-icons/bs";
import { BsTextCenter as TextCenterIcon } from "react-icons/bs";
import { BsTextRight as TextRightIcon } from "react-icons/bs";
import { PiTextAlignJustify as TextJustifyIcon } from "react-icons/pi";
import { MdFormatListBulleted as BulletListIcon } from "react-icons/md";
import { MdOutlineFormatListNumbered as OrderedListIcon } from "react-icons/md";
import {
  IFontFormatButton,
  IHeadingButton,
  IListButton,
  ITextAlignButton,
} from "../ToolbarButtons/types";

export const FORMAT_BTNS: IFontFormatButton[] = [
  {
    format: "bold",
    icon: BoldIcon,
  },
  {
    format: "italic",
    icon: ItalicIcon,
  },
  {
    format: "underline",
    icon: UnderlineIcon,
  },
  {
    format: "strike",
    icon: StrikeIcon,
  },
];

export const HEADING_BTNS: IHeadingButton[] = [
  {
    icon: H1Icon,
    level: 1,
  },
  {
    icon: H2Icon,
    level: 2,
  },
  {
    icon: H3Icon,
    level: 3,
  },
];

export const TEXT_ALIGHT_BTNS: ITextAlignButton[] = [
  {
    icon: TextLeftIcon,
    textAlign: "left",
  },
  {
    icon: TextCenterIcon,
    textAlign: "center",
  },
  {
    icon: TextRightIcon,
    textAlign: "right",
  },
  {
    icon: TextJustifyIcon,
    textAlign: "justify",
  },
];

export const LIST_BTNS: IListButton[] = [
  {
    icon: BulletListIcon,
    listType: "bulletList",
  },
  {
    icon: OrderedListIcon,
    listType: "orderedList",
  },
];
